import IconX from "./IconX";
const CheckListError = function (props) {
	return (
		<p className="error"><IconX /> {props.text}</p>
	);
}

export default CheckListError;